import React, { useState } from 'react';
import NavBar from '../navbar/navbar';
import Footer from '../navbar/footer';
import Input from '../../components/input';
import { AiOutlineSend } from 'react-icons/ai';
import { PiLightbulbFilament } from 'react-icons/pi';
import InsightsActions from './insights';
import BusinessNarratives from './narratives';
import data from './data.json';
import './css/style.scss';

const HomePage = (props) => {
  const [query, setQuery] = useState('');
  const [date, setDate] = useState('');

  const shuffled = data.suggested_insights.sort(function () {
    return 0.5 - Math.random();
  });
  const questions = shuffled.slice(0, 3);

  const handleChange = ({ currentTarget: input }) => {
    setQuery(input.value);
  };

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      submitQuery();
    }
  };

  const submitQuery = (q = '') => {
    const userquery = q.length !== 0 ? q : query;
    window.location = '/chat?query=' + userquery;
  };

  //Component 1
  const SearchBox = (
    <div className='place-container'>
      <div className='ask-question mb-4'>
        <img src='./logo192.png' alt='AI' />
        <h5 className='m-0'>Ask a Question</h5>
      </div>
      <div className='ask-search'>
        <Input
          name='username'
          placeholder='Start exploring with your questions or use suggested insights'
          type='text'
          icon={<AiOutlineSend />}
          iconposition='right'
          iconclass='send'
          iconclick={() => submitQuery(query)}
          customclass='mb-4'
          value={query || ''}
          handleChange={handleChange}
          handleKeyDown={handleKeyDown}
        />
      </div>
    </div>
  );

  //Component 2
  const SuggestedInsights = (
    <div className='suggested-insights mt-4 place-container'>
      <div className='heading'>
        <PiLightbulbFilament /> Suggested Insights
      </div>
      <div className='insights'>
        {questions.map((x, i) => {
          return (
            <div className='queries' key={i} onClick={() => submitQuery(x)}>
              {x}
            </div>
          );
        })}
      </div>
    </div>
  );

  return (
    <div id='home-page'>
      <NavBar />
      <div className='flex-fill d-flex justify-content-center overflow-auto row m-0'>
        <div className='content reduced-row'>
          <div className='row m-0'>
            <div className='col-xs-12 col-md-9 col-lg-9'>
              {SearchBox}
              <BusinessNarratives
                user={props.user}
                updateDate={(s) => setDate(s)}
              />
              {SuggestedInsights}
            </div>
            <div className='col-xs-12 col-md-3 col-lg-3'>
              <InsightsActions user={props.user} date={date} />
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </div>
  );
};

export default HomePage;
